import { render, staticRenderFns } from "./MissionCardGang.vue?vue&type=template&id=b0708e80&scoped=true&"
import script from "./MissionCardGang.vue?vue&type=script&lang=js&"
export * from "./MissionCardGang.vue?vue&type=script&lang=js&"
import style0 from "./MissionCardGang.vue?vue&type=style&index=0&id=b0708e80&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0708e80",
  null
  
)

export default component.exports